import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import autoComplete from '@tarekraafat/autocomplete.js';
import { mark } from '@tarekraafat/autocomplete.js/src/helpers/io';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Breakpoints, Classes, Durations, Events } from './constants';
import { fixMobileHover, sortAnimations, initGTM, setCookiesAllowed, setDisclaimerAccepted, scrollTo, wait } from './helpers';

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Fix VH ----------

$Elements.window.on('resize', () => {
	document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);

	if(window.innerWidth >= Breakpoints.sm) {
		document.documentElement.style.setProperty('--mobile-vh', `${window.innerHeight}px`);
	}
});
$Elements.window.trigger('resize');

$Elements.window.on('orientationchange', async() => {
	await wait(100);
	document.documentElement.style.setProperty('--mobile-vh', `${window.innerHeight}px`);
});
$Elements.window.trigger('orientationchange');

// ---------- Fix Mobile Hover ----------

$Elements.window.on('load', () => fixMobileHover());

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, () => {

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.body.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.body.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			scrollTo(target, Durations.animations.ms);
		}
	});

	$Elements.body.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		GLightbox({
			selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
		});
	});

	$('[target^="lightbox-gallery"]').each(function() {

		GLightbox({
			selector: 'a[target="' + this.attributes.target.value + '"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
			loop: true,
		});
	});

	// ---------- Disclaimer ----------

	$('#disclaimer').addClass(Classes.loaded);

	$('#disclaimer').on('close.bs.alert', function() {
		setDisclaimerAccepted();
		$Elements.body.removeClass('disclaimer-open');
		$Elements.document.trigger('disclaimer-closed');
	});

	// ---------- Cookies ----------

	initGTM();

	$('#cookies-allowed').on('click', '[data-bs-dismiss="alert"]', function() {
		setCookiesAllowed(this.dataset.allowed);
	});

	// ---------- Collapse Read more ----------

	$('[data-bs-toggle="collapse"].read-more-btn').each(function() {

		const self = $(this);
		const collapse = self.parent().siblings('.collapse');
		const closeButton = self.siblings('.close-btn');

		collapse.on('show.bs.collapse', function() {
			self.addClass('d-none');
			closeButton.removeClass('d-none');
		})

		collapse.on('hide.bs.collapse', function() {
			self.removeClass('d-none');
			closeButton.addClass('d-none');
		})
	});

	if(typeof wines_autocomplete_suggestions !== 'undefined') {

		$('.wine-search').each(function() {

			const wineAutoComplete = new autoComplete({
				name: 'wine-search',
				selector: () => this,
				diacritics: true,
				searchEngine: (query, record) => {
					record = record.name;

					const format = value => {
						value = value.toString().toLowerCase();

						return value
							.normalize('NFD')
							.replace(/[\u0300-\u036f]/g, '')
							.normalize('NFC')
							.replace(/[^a-zA-Z]/g, ' ')
							.replace(/\s\s+/g, ' ')
					};

					const nRecord = format(record);
					record = record.toString();
					query = format(query);

					let match = nRecord.indexOf(query);

					if(~match) {
						query = record.substring(match, match + query.length);
						match = record.replace(query, mark(query, true));

						return match;
					}
				},
				data: {
					src: wines_autocomplete_suggestions.suggestions,
					cache: true,
				},
				resultsList: {
					tag: 'div',
					id: 'wine-search-list',
					class: 'list-group list-group-flush',
					maxResults: 6,
				},
				resultItem: {
					tag: 'a',
					id: 'wine-search-result',
					class: 'list-group-item',
					highlight: true,
					element: (item, data) => {
						item.setAttribute('href', data.value.href)
						$(item).on('click', async function() {
							$(wineAutoComplete.input).val($(this).text());
							await wait(100);
							wineAutoComplete.close();
							$(wineAutoComplete.input).closest('form').submit();
						});
					},
				},
				events: {
					input: {
						focus: () => {
							if(wineAutoComplete.input.value.length) wineAutoComplete.start();
						}
					},
				},
			});
		});
	}
});
